import { IUrl, IUrlService } from './types';
import { Url } from './Url';

export interface IUrlFactory {
  createUrl(urlService: IUrlService, url?: string): IUrl;
}

export class BrowserUrlFactory implements IUrlFactory {
  createUrl(urlService: IUrlService, url?: string): IUrl {
    return new Url(urlService, url ?? window.location.href);
  }
}
